import React, { Fragment } from 'react';
import { 
    Show,
    SimpleShowLayout,
    TextField,
    NumberField,
    ImageField,
    ShowProps,
    RichTextField,
    DateField
} from 'react-admin'
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((table) => ({
  description: {
    width:600
  },
  content:{
    width:800
  }
}))

export const InfluencerShow = (props: ShowProps) => (
    <Show {...props}>
        <SimpleShowLayout>
           <TextField source="id" label="ID" />
            <TextField source="name_en" label="Name (English)" />
            <TextField source="name_ar" label="Name (Arabic)" />
            <ImageField source="featured_image" label="Featured Image" />
            <NumberField source="video_url" label="Video Url" />
            <NumberField source="active" label="Active" />
            <DateField source="created_at" label="Created At" />
            <DateField source="updated_at" label="Updated At" />
        </SimpleShowLayout>
    </Show>
);

export default InfluencerShow;